import type { FieldErrors, FieldValues } from "react-hook-form";
import { useFormContext } from "@/providers/form.provider";

type FormGroupProps<T extends FieldValues> = {
  onSubmit: (
    values: T,
    errors?: Record<keyof T, string>,
  ) => void | Promise<void>;
  children: React.ReactNode;
  id?: string;
  className?: string;
};

function FormGroup<T extends FieldValues>({
  onSubmit,
  children,
  id = "",
  className = "",
}: FormGroupProps<T>) {
  const { handleSubmit } = useFormContext<T>();

  const submitHandler = handleSubmit(
    (values) => {
      onSubmit(values);
    },
    (formErrors: FieldErrors<T>) => {
      const errorMap = Object.fromEntries(
        Object.entries(formErrors).map(([key, value]) => [
          key,
          value?.message as string,
        ]),
      ) as Record<keyof T, string>;

      onSubmit({} as T, errorMap);
    },
  );

  return (
    <form
      id={id}
      className={`space-y-4 ${className}`}
      onSubmit={submitHandler}
      noValidate
    >
      {children}
    </form>
  );
}

export default FormGroup;
